import {QueryParams} from '@ngrx/data';
import {Observable} from 'rxjs';
import {AbstractDataServiceAdapter} from './abstractDataService.adapter';
import {PlainDtoModel} from '../../../../../common/entity/dto/plain/plainDto.model';
import {HttpModelConverter} from '../../../../converter/httpModel.converter';
import {Page} from '../../../../../../shared/model/core/page.model';

export abstract class AbstractDataServiceDtoAdapter<
    T extends PlainDtoModel,
    C extends HttpModelConverter<T>>
    extends AbstractDataServiceAdapter<T, T, C> {

    getDtos(path: string, params?: string | QueryParams): Observable<Page<T>> {
        return super.getMultipleWithQuery(path, params);
    }

    getOneDto(path: string, params?: string | QueryParams): Observable<T> {
        return super.getOneWithQuery(path, params);
    }

    buildEntityFromStoreEntity(storedEntity: T): T {
        return this.converter.convert(storedEntity);
    }

    buildStoredEntityEntity(entity: T): T {
        return entity;
    }

    isDtoSummary(): boolean {
        return false;
    }

}
